import { ReactNode } from 'react';
import { IconButton, Tooltip } from '@mui/material';

function TooltipIconButton({ comingSoon, icon, path }: { comingSoon?: boolean; icon: ReactNode; path?: string }) {
  const iconOuterResponsiveWH = { xs: '40px', sm: '45px', md: '50px' };

  return (
    <>
      {comingSoon ? (
        <Tooltip title="Coming Soon">
          <a href={path} target="_blank" rel="noopener noreferrer">
            <IconButton>{icon}</IconButton>
          </a>
        </Tooltip>
      ) : (
        <a href={path} target="_blank" rel="noopener noreferrer">
          <IconButton
            sx={{
              width: iconOuterResponsiveWH,
              height: iconOuterResponsiveWH,
              border: '2px solid white',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
            }}
          >
            {icon}
          </IconButton>
        </a>
      )}
    </>
  );
}

export default TooltipIconButton;
